import { BlockBase, HeadlineHeader } from "components/page/user/contract/edit/parts/blockBase";
import React from "react";
import * as dateUtil from "util/dateUtil";

/** 宅地建物取引業者・宅地建物取引士（右） */
export default class Block4 extends BlockBase {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            headlineId: "030304",
        };
    }

    render() {
        const { hideBlockClass } = this.renderCommon();

        // 非表示判定の場合、null(react的な表示なし)を返す
        if (this.dohide(this.props.pageState.hidingHeadline)) { return null; }

        let { era } = dateUtil.genEraText(this.props.pageState.JYU00053);

        return (
            <div className={`dataList dataList__accordion ${hideBlockClass}`}>
                <div className="dataList-header">
                    <div className="dataList-header-title">宅地建物取引業者・宅地建物取引士（右）</div>
                    <HeadlineHeader onClick={this.handleHide} hide={this.state.hide} />
                </div>
                <div className="dataList-body">
                    <table className="dataTable">
                        <tbody>
                            <tr>
                                <th className="dataTable-title is-emphasis" colSpan="4">宅地建物取引業者</th>
                            </tr>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">免許番号</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00052}</td>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">免許年月日</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00053}&nbsp;{era}</td>
                            </tr>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">住所</th>
                                <td className="dataTable-body dataTable-body__w355" colSpan="3">{this.props.pageState.JYU00054}</td>
                            </tr>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">法人名</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00056}</td>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">代表者名</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00057}</td>
                            </tr>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">部署名</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00060}</td>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">担当者名</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00062}</td>
                            </tr>
                            <tr>
                                <th className="dataTable-title is-emphasis" colSpan="4">宅地建物取引士</th>
                            </tr>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">登録番号</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00063}</td>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">氏名</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00064}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}